import dayjs from 'dayjs';
import StockService from '@/services/StockService';
import { filterMap } from '@/utils/helper';

// state
const localState = {
  autoLoad: {
    loading: false,
    loader: StockService.getAll,
    emptyMap: {}
  },
  stockItems: {},
  units: {},
  counts: {},
  stocks: {}
};

// getters
const localGetters = {
  getCurrentCount: (state, getters) => stockItemId => {
    const stock = getters
                    .getArray('stocks')
                    .find(stock => stock.stockItem == stockItemId);
    if(!stock) return 0;
    return stock.currentCount;
  },
  getStock: (state, getters) => stockItemId => {
    return getters
                    .getArray('stocks')
                    .find(stock => stock.stockItem == stockItemId);
  },
  getStockItemClone: (state, getters) => (stockItem, list = null) => {
    let stockItems = list;
    if (!list) {
      stockItems = getters.getCloneStockItemList;
    }
    return stockItems.find(s => s.cloneId == stockItem.masterId);
  },
  getStockItemProperty: (state, getters) => (stockItem, property, list = null) => {
    const clone = getters.getStockItemClone(stockItem, list);
    return clone ? clone[property] : stockItem[property];
  },
  getCloneStockItemList: (state, getters) => {
    return getters.getArray('stockItems', false, false).filter(s => s.cloneId);
  }
};

export default {
  state: localState,
  getters: localGetters,
};